import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArrowRight from '@material-ui/icons/ArrowRight';
import Table from '@material-ui/core/Table';
import { Pagination } from '@iris-platform/iris-react-ui';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Collapse } from '@material-ui/core';
import classNames from 'classnames';
import * as _ from 'lodash';
import {
  stylesToPropType,
} from '../../utils';

const styles = theme => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    padding: 0,
  },
  table: {
    minWidth: '100%',
  },
  childTable: {
    minWidth: '100%',
    padding: '0px 0px 0px 0px',
    height: '0px',
  },
  inactive: {
    display: 'none',
  },
  success: {
    // color: '#86C35D',
  },
  failure: {
    color: '#DC2620',
    fontWeight: 'bold',
  },
  centerPagination: {
    margin: 'auto',
    width: '50%',
  },
  carot: {
    transform: 'rotate(0deg)',
    transition: 'transform 0.5s linear',
  },
  expand: {
    transform: 'rotate(90deg)',
    transition: 'transform 0.5s linear',
  },
  rowTable: {
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    paddingLeft: '2px',
    paddingRight: '4px',
  },
  cellTable: {
    fontSize: '12px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    paddingLeft: '2px',
    paddingRight: '4px',
  },
  childRowTable: {
    fontSize: '11px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    paddingLeft: '2px',
    paddingRight: '4px',
    // padding: '0px 0px 0px 0px',
    // height: '0px',
  },
  childCellTable: {
    fontSize: '11px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    paddingLeft: '2px',
    paddingRight: '4px',
    // padding: '0px 0px 0px 0px',
    // height: '0px',
  },
  noRecords: {
    textAlign: 'center',
    color: 'red',
    fontSize: '15px',
    padding: '10px',
    margin: '15px auto',
    border: '1px dotted red',
  },

});

class NtmTrace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1, recordsPerPage: 10, ntmDetailsData: this.props.ntmDetailsData, previousPage: 1,
    };
    this.handleArrowClick = this.handleArrowClick.bind(this);
    this.renderAdditionalInfo = this.renderAdditionalInfo.bind(this);
    this.onClickPage = this.onClickPage.bind(this);
  }

  // when new searchcompletes, bring the user back to the first page and close all open rows
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.ntmDetailsData && prevProps.ntmDetailsData) {
      if ((this.props.ntmDetailsData.length != prevProps.ntmDetailsData.length)
      || (this.props.ntmDetailsData.length > 0 && prevProps.ntmDetailsData.length > 0 && prevProps.ntmDetailsData[0].traceId !== this.props.ntmDetailsData[0].traceId)
      ) {
        // console.log("inside didUpdate")
        this.setState({ currentPage: 1, ntmData: null });
      }
    }
  }

  componentWillMount = async () => {
    const { ntmDetailsData } = this.props;
  }

  onClickPage = async (currentPage) => {
    this.state.previousPage = this.state.currentPage;
    // when page is changed close open rows
    if (currentPage != this.state.previousPage) {
      this.setState({ ntmData: null });
    }
    this.setState({ currentPage });
  }


  formatTime = (date) => {
    const dateString = date ? new Date(date).toLocaleString() : 'Incomplete/Missing';
    return dateString;
  }

  handleArrowClick = (data, index) => {
    const { ntmData } = this.state;
    let ntmDetail = { index };
    if (ntmData && index === ntmData.index) {
      ntmDetail = null;
    }
    this.setState({ ntmData: ntmDetail });
  }

  renderAdditionalInfo = (messageData) => {
    const { classes } = this.props;
    const message = messageData;
    return (
      <Table className={classes.childTable} padding="dense">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell className={classes.childRowTable}>Attribute</TableCell>
            <TableCell className={classes.childRowTable}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
              Object.keys(message).map(key => (
                <TableRow key={key}>
                  <TableCell />
                  <TableCell className={classes.childCellTable} component="th" scope="row">{key}</TableCell>
                  <TableCell className={classes.childCellTable} component="th" scope="row">{(typeof (message[key]) !== 'object' ? message[key].toString() : JSON.stringify(message[key]))}</TableCell>
                </TableRow>
              ))
            }
        </TableBody>
      </Table>
    );
  }

  render() {
    const { ntmDetailsData, searchDone } = this.props;
    const { classes } = this.props;
    const newPage = this.state.currentPage;
    const pageRowsCount = this.state.recordsPerPage;
    if (searchDone && ntmDetailsData.length === 0) {
      return <div className={classes.noRecords}>No NTM traces found for given traceId</div>;
    }
    const showNtmDetailsData = [];
    // for first page show only as per row count
    if (searchDone && ntmDetailsData.length > 0) {
      for (let i = 0; i < pageRowsCount && (i + ((newPage - 1) * 10) < ntmDetailsData.length); i++) {
        showNtmDetailsData.push(ntmDetailsData[i + ((newPage - 1) * 10)]);
      }
    }
    return (
      <div className={classes.callDetailsWrapper}>
        <Table className={classes.table} padding="dense" size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell className={classes.rowTable}>Timestamp</TableCell>
              <TableCell className={classes.rowTable}>Message </TableCell>
              <TableCell className={classes.rowTable}>TraceId</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              showNtmDetailsData.map((ntmData, index) => {
                const showInfo = this.state.ntmData && (this.state.ntmData.index === index);
                const className = (ntmData.code === 'error') ? classes.failure : classes.success;
                // const Message = (ntmData.Message ) ? ntmData.Message : 'expand row to check details';
                let customMessage = '';
                if (!ntmData.Message) {
                  const parsedMessage = JSON.parse(ntmData.message);
                  if (parsedMessage.type) { customMessage = `${customMessage + parsedMessage.type}-`; }
                  if (parsedMessage.module) { customMessage = `${customMessage + parsedMessage.module}-`; }
                  if (parsedMessage.eventType) { customMessage = `${customMessage + parsedMessage.eventType}-`; }
                  if (parsedMessage.notificationType) { customMessage = `${customMessage + parsedMessage.notificationType}-`; }
                  if (customMessage.length > 1) {
                    customMessage = customMessage.substring(0, customMessage.length - 1);
                  } else {
                    customMessage = 'expand row to check details';
                  }
                } else {
                  customMessage = ntmData.Message;
                }
                const Message = customMessage;
                return [
                  <TableRow key={ntmData.traceId + ntmData.timestamp}>
                    <TableCell className={classes.cellTable} component="th" scope="row" onClick={() => this.handleArrowClick(ntmData, index)}>
                      <ArrowRight
                        className={classNames(classes.carot, { [classes.expand]: showInfo })}
                      />
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      <div className={className}>
                        {ntmData.timestamp}
                      </div>
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">
                      <div className={className}>
                        {Message}
                      </div>
                    </TableCell>
                    <TableCell className={classes.cellTable} component="th" scope="row">

                      <div className={className}>
                        {ntmData.traceId}
                      </div>
                    </TableCell>
                  </TableRow>,
                  <TableRow key={`${ntmData.traceId + ntmData.timestamp}.details`} className={showInfo ? classes.active : classes.inactive}>
                    <TableCell className={classes.cellTable} colSpan={1} />

                    <TableCell className={classes.cellTable} colSpan={7}>
                      <Collapse in={showInfo}>
                        {this.renderAdditionalInfo(JSON.parse(ntmData.message))}
                      </Collapse>
                    </TableCell>
                  </TableRow>,
                ];
              })}
          </TableBody>
        </Table>
        <br />
        <div className={classes.centerPagination}>
          <Pagination
            title="ntmDetailsPagination"
            totalRecords={ntmDetailsData.length}
            recordsPerPage={10}
            currentPage={this.state.currentPage}
            onClickPage={this.onClickPage}
            thresholdPageBtns={5}
          />
        </div>
      </div>
    );
  }
}

NtmTrace.propTypes = {
  classes: stylesToPropType(styles()).isRequired,
  ntmDetailsData: PropTypes.array.isRequired,
  searchDone: PropTypes.bool.isRequired,
};

export default withStyles(styles)(NtmTrace);
